import { AxiosPromise } from 'axios';
import { client }       from '@/service/client';

export function getReportsList(): AxiosPromise {
  return client.get('/features/dynamic-tables');
}

export function deleteTable(tableUuid: string): AxiosPromise {
  return client.delete(`/features/dynamic-tables/${tableUuid}`);
}

export function copyTable(tableUuid: string, tableName: string): AxiosPromise {
  return client.put('/features/dynamic-tables/copy', {
    name: tableName,
    tableUuid,
  });
}

export function exportToExcel(tableUuid: string): AxiosPromise {
  return client.get(`/features/dynamic-tables/${tableUuid}/excel`, {
    responseType: 'blob',
  });
}
